import React from 'react';

import Item from './Item';

type ListProps = {
  children: React.ReactNode;
  className?: string;
};

function List({children, className}: ListProps) {
  return (
    <div className="flex flex-wrap">
      {React.Children.map(children, child => (
        <div className={className || ''}>{child}</div>
      ))}
    </div>
  );
}

List.Item = Item;

export default List;
